import { render } from "./MaterialForm.vue?vue&type=template&id=1b74418c&scoped=true"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"

import "./MaterialForm.vue?vue&type=style&index=0&id=1b74418c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b74418c"]])

export default __exports__